export function formatDreamAddress(addr: string) {
  if (addr.length !== 12) return `DA-${addr.substr(0, 12)}`;

  return `DA-${addr.substring(0, 4)}-${addr.substring(4, 8)}-${addr.substring(
    8,
  )}`;
}
